import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GMailService, ItemToSell } from 'src/app/_services';
import { Chat, ChatService } from 'src/app/_services/chat.service';
import { Profile, ProfileService } from 'src/app/_services/profiles.service';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { environment } from 'src/environments/environment';
import { SidenavService } from 'src/app/_services/sidenav.service';

class ChatRow {
  constructor(readonly item: ItemToSell, public totalUnreadMessages: number, public totalMessages: number) {}
}

@Component({
  templateUrl: './all-chats-page.component.html',
  styleUrls: ['./all-chats-page.component.scss']
})
export class AllChatsPageComponent extends MaterialPage {
  
  chats: Chat[] | undefined;
  selling: ChatRow[] | undefined;
  buying: ChatRow[] | undefined;
  picturesUrl = environment.picturesUrl;
  columnsToDisplay = ["image", "title"];
  private profile: Profile;
  loading: boolean = true;
  
  constructor(
    breakpointObserver: BreakpointObserver,
    private profileService: ProfileService,
    private chatService: ChatService,
    private router: Router,
    titleService: Title,
    sidenavService: SidenavService,
    meta: Meta) {
      
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:Conversations`, '', true);
  }
  
  private groupChats() {
    
    const byItem = new Map<number, ChatRow>();
    
    this.chats!.forEach(chat => {
      
      let chatRow = byItem.get(chat.itemToSell.id);
      
      if (chatRow) {
        chatRow.totalMessages += chat.totalMessages;
        chatRow.totalUnreadMessages += chat.unreadMessages;
      } else {
        byItem.set(chat.itemToSell.id, new ChatRow(chat.itemToSell, chat.unreadMessages, chat.totalMessages));
      }
    });
    
    this.selling = [...byItem.values()].filter(row => row.item.ownerNickName === this.profile.username);
    this.buying = [...byItem.values()].filter(row => row.item.ownerNickName !== this.profile.username);
  }
  
  async ngOnInit() {
    
    const [profiles, chats] = await Promise.all([
      this.profileService.list(),
      this.chatService.listChats()]);
    
    this.profile = profiles[0];
    this.chats = chats;
    this.groupChats();
    
    this.loading = false;
  }
  
  viewListingChats(itemId: number) {
    this.router.navigate(["/chats/listings/" + itemId]);
  }
  
  viewListing(itemId: number) {
    this.router.navigate(["/view-listing/" + itemId]);
  }
  
  integrated() {
    this.router.navigate(['/items-to-sell']);
  }
}
